import React, { useEffect } from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from '../Header';
import Footer from '../Footer';

import hrmian from "../../img/hero/hero2-main-img.png"
import hrco from "../../img/hero/hero2-coin.png"
import dsh from "../../img/hero/hero2-dashboard1.png"
import dsh2 from "../../img/hero/hero2-dashboard2.png"
import FooterImg from "../../img/logo/footer-logo1.png"
import footerimg1 from '../../img/shapes/footer2-element.png'
import coinImg2 from "../../img/others/cta2-dashboard.png"
import cta1 from "../../img/shapes/cta2-coin.png"
import cta2 from "../../img/shapes/cta2-shape.png"
import authorImg from "../../img/shapes/cta2-circle1.png"
import dateImg from "../../img/shapes/cta2-circle2.png"
import blogImg from "../../img/blog/blog2-img1.png"
import blogImg5 from "../../img/blog/blog1-image2.png"
import test1 from "../../img/shapes/tes2-shape.png"
import testiii2 from "../../img/shapes/about2-shape.png"
import mapimg1 from "../../img/testimonial/tes1-img1.png"
import mapimg2 from "../../img/testimonial/tes1-img2.png"
import mapimg3 from "../../img/testimonial/tes1-img3.png"
import mapimg4 from "../../img/testimonial/tes1-img4.png"
import mapimg5 from "../../img/testimonial/tes1-img5.png"
import mapimg6 from "../../img/testimonial/tes1-img6.png"
import iconImg2 from "../../img/icons/tes1-icon.png"
import bankicon1 from "../../img/icons/bank1.svg"
import bankicon2 from "../../img/icons/bank2.svg"
import bankicon3 from "../../img/icons/bank3.svg"
import heromob from "../../img/hero/hero1-mobile1.png"
import heromob1 from "../../img/hero/hero1-mobile2.png"
import heromob2 from "../../img/hero/hero1-mobile3.png"
import heromain from "../../img/hero/hero1-main.png"
import app1 from "../../img/hero/app1.png"
import app2 from "../../img/hero/app2.png"
import appqr from "../../img/hero/qr.png"
import appARROW from "../../img/shapes/arrow.png"
import about1 from "../../img/bg/about1-shape-bg.png"
import about2 from "../../img/shapes/about1-shape.png"
import about3 from "../../img/about/about1-img1.png"
import about4 from "../../img/about/about1-img2.png"
import about5 from "../../img/about/about1-img3.png"
import abouticon1 from "../../img/icons/about1-icon1.svg"
import abouticon2 from "../../img/icons/about1-icon2.svg"
import othed from "../../img/others/others2-main-img.png"
import other from "../../img/others/others2-btn1.png"
import other2 from "../../img/others/others2-btn2.png"
import qt from "../../img/icons/tes2-qute.png"
import qt2 from "../../img/testimonial/tes2-bottom-img.png"
import tsetbtn from "../../img/testimonial/tes2-bottom-img.png"
import qut from "../../img/icons/tes2-qute.png"
import test2 from "../../img/testimonial/tes2-img.png"
import selt from "../../img/icons/token-sell-icon3.svg"
import sell from "../../img/shapes/token-sell-shape1.png"
import sell2 from "../../img/shapes/token-sell-shape2.png"
import sell3 from "../../img/shapes/token-sell-shape3.png"
import sell4 from "../../img/shapes/token-sell-shape4.png"
import bnk4 from "../../img/logo/bank4.png"
import bnk3 from "../../img/logo/bank3.png"
import bnk2 from "../../img/logo/bank2.png"
import bnk from "../../img/logo/bank1.png"
import abtim from "../../img/icons/about2-icon3.svg"
import service from "../../img/icons/service1-icon1.svg"
import abttmn from "../../img/icons/about2-icon2.svg"
import abtmn3 from "../../img/icons/about2-icon1.svg"
import abtmn2 from "../../img/shapes/about2-shape.png"
import abc2 from "../../img/icons/token-sell-icon1.svg"
import abc from "../../img/icons/BankImg1.png"
import headlogo from "../../img/logo/header-logo2.png"
import service8 from "../../img/demo/demo1.png"
import service9 from "../../img/demo/demo2.png"
import service99 from "../../img/demo/demo3.png"
import sere from "../../img/demo/demo4.png"
import service10 from "../../img/shapes/hero2-circle-shape1.png"
import service101 from "../../img/shapes/hero2-circle-shape2.png"
import service102 from "../../img/shapes/hero2-bet-coin-shape.png"
import service103 from "../../img/shapes/hero2-bottom-shape.png"
import aboumain from "../../img/bg/about2-bg-shape.png"
import abtmain from "../../img/about/about2-main-img.png"
import abtmn from "../../img/hero/hero2-coin.png"
import tokenimg from "../../img/icons/token-sell-icon4.svg"
import tatimg from "../../img/shapes/token-sell-sec-shape.png"
import workimg2 from "../../img/icons/work2-icon1.svg"
import workimg3 from "../../img/icons/work2-icon2.svg"
import workimg4 from "../../img/icons/work2-icon3.svg"
import workimg from "../../img/shapes/work2-shape.png"
import shapimg from "../../img/shapes/about2-shape.png"
import roadmap from "../../img/shapes/roadmap-shape.png"
import { faStar } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import SwiperCore from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import { faFacebookF, faGooglePlusG, faInstagram, faLinkedinIn, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { useNavigate } from 'react-router-dom';

SwiperCore.use([Navigation, Autoplay]);

const SingleHomepage = () => {
    useEffect(() => {
        AOS.init({
            duration: 800,  // You can set the duration here or directly in the HTML as data-aos-duration
        });
    }, []);

    const navigate = useNavigate();

    return (
        <>
            <div className="body2" style={{ backgroundColor: "#02020A", zIndex: "-33" }}>

                <div class="header-area header-area2 header-area-all d-none d-lg-block" id="header">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="header-elements">
                                    <div class="site-logo">
                                        <a href="/">
                                            <img src={headlogo} alt="" />
                                        </a>
                                    </div>


                                    <div class="main-menu-ex main-menu-ex1">
                                        <ul>
                                            <li><a href="#">Home <i class="fa-solid fa-angle-down"></i></a>
                                                <div class="tp-submenu">
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <div class="all-images-menu">
                                                                <div class="homemenu-thumb">
                                                                    <div class="img1">
                                                                        <img src={service8} alt="" />
                                                                    </div>
                                                                    <div class="homemenu-btn">
                                                                        <a class="header-btn1" href="/">Multi Page <i class="fa-solid fa-arrow-right"></i></a>
                                                                        <div class="space16"></div>
                                                                        {/* <a class="header-btn1" href="/singlePage" target="_blank">One page <i class="fa-solid fa-arrow-right"></i></a> */}
                                                                        <a class="header-btn1" onClick={() => navigate('/singlePage')} >One page <i class="fa-solid fa-arrow-right"></i></a>
                                                                    </div>
                                                                </div>

                                                                <div class="homemenu-thumb">
                                                                    <div class="img1">
                                                                        <img src={service9} alt="" />
                                                                    </div>
                                                                    <div class="homemenu-btn">
                                                                        {/* <a class="header-btn1" href="/homeMultipage">Multi Page <i class="fa-solid fa-arrow-right"></i></a> */}
                                                                        <a class="header-btn1" onClick={() => navigate("/homeMultipage")} >Multi Page <i class="fa-solid fa-arrow-right"></i></a>
                                                                        <div class="space16"></div>
                                                                        {/* <a class="header-btn1" href="/home2MultiPage" target="_blank">One page <i class="fa-solid fa-arrow-right"></i></a> */}
                                                                        <a class="header-btn1" onClick={() => navigate("/homeSinglePage")} >One page <i class="fa-solid fa-arrow-right"></i></a>
                                                                    </div>
                                                                </div>


                                                                <div class="homemenu-thumb">
                                                                    <div class="img1">
                                                                        <img src={service99} alt="" />
                                                                    </div>
                                                                    <div class="homemenu-btn">
                                                                        <a class="header-btn1" href="/home2MultiPage">Multi Page <i class="fa-solid fa-arrow-right"></i></a>
                                                                        <div class="space16"></div>
                                                                        {/* <a class="header-btn1" href="/home2SinglePage" target="_blank">One page <i class="fa-solid fa-arrow-right"></i></a> */}
                                                                        <a class="header-btn1" onClick={() => navigate("/home2SinglePage")} >One page <i class="fa-solid fa-arrow-right"></i></a>
                                                                    </div>
                                                                </div>

                                                                <div class="homemenu-thumb" style={{ margin: "0" }}>
                                                                    <div class="img1">
                                                                        <img src={sere} alt="" />
                                                                    </div>
                                                                    <div class="homemenu-btn">
                                                                        {/* <a class="header-btn1" href="/homeIndexMultiPage">Multi Page <i class="fa-solid fa-arrow-right"></i></a> */}
                                                                        <a class="header-btn1" onClick={() => navigate("/homeIndexMultiPage")} >Multi Page <i class="fa-solid fa-arrow-right"></i></a>
                                                                        <div class="space16"></div>
                                                                        {/* <a class="header-btn1" href="single-/homeIndexMultiPage" target="_blank">One page <i class="fa-solid fa-arrow-right"></i></a> */}
                                                                        <a class="header-btn1" onClick={() => navigate("/homeIndexSinglePage")} >One page <i class="fa-solid fa-arrow-right"></i></a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>

                                            <li><a href="/about">About Us</a></li>

                                            <li class="dropdown-menu-parrent"><a href="#" class="main1" >Market <i class="fa-solid fa-angle-down"></i></a>
                                                <ul>
                                                    <li><a href="/market">Market Update</a></li>
                                                    <li><a href="/buyCrypto">Buy Crypto</a></li>
                                                    <li><a href="/sellBuyCrypto">Sell Crypto</a></li>
                                                </ul>
                                            </li>

                                            <li class="dropdown-menu-parrent"><a href="#" class="main1">Pages <i class="fa-solid fa-angle-down"></i></a>
                                                <ul>
                                                    <li><a href="/contact">Contact</a></li>
                                                    <li><a href="/faq">FAQ</a></li>
                                                    <li><a href="/error">404</a></li>
                                                </ul>
                                            </li>

                                            <li class="dropdown-menu-parrent"><a href="#" class="main1">Blog <i class="fa-solid fa-angle-down"></i></a>
                                                <ul>
                                                    <li><a href="/blog">Blog</a></li>
                                                    <li class="has-dropdown has-dropdown1"><a href="/blogDetail" class="main">Blog Detials<span><i class="fa-solid fa-angle-right"></i></span></a>
                                                        <ul class="sub-menu">
                                                            <li><a href="/blogDetailLeft">Details Left</a></li>
                                                            <li><a href="/blogDetailRight">Details Right</a></li>
                                                            <li><a href="/blogDetail">Single Details</a></li>
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </li>

                                            <li class="dropdown-menu-parrent"><a href="#" class="main1">Account <i class="fa-solid fa-angle-down"></i></a>
                                                <ul>
                                                    <li><a href="/user">My Profile</a></li>
                                                    <li><a href="/login">Login</a></li>
                                                    <li><a href="/register">Register</a></li>
                                                </ul>
                                            </li>


                                        </ul>
                                    </div>



                                    <div class="header2-buttons">
                                        <div class="button">
                                            <a href="/register" class="btn_theme btn_theme_active mt_40 wow fadeInDown" data-wow-duration="0.8s">Get Started Today <i class="fa-solid fa-arrow-right"></i><span></span></a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mobile-header mobile-header2 mobile-header-main d-block d-lg-none ">
                    <div class="container-fluid">
                        <div class="col-12">
                            <div class="mobile-header-elements">
                                <div class="mobile-logo">
                                    <a href="/"><img src={headlogo} alt="" /></a>
                                </div>
                                <div class="mobile-nav-icon">
                                    <i class="fa-duotone fa-bars-staggered"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mobile-sidebar mobile-sidebar2 d-block d-lg-none">
                    <div class="logo-m">
                        <a href="/"><img src={headlogo} alt="" /></a>
                    </div>
                    <div class="menu-close">
                        <i class="fa-solid fa-xmark"></i>
                    </div>
                    <div class="mobile-nav">

                        <ul>
                            <li class="has-dropdown"><a href="#">Home </a>
                                <ul class="sub-menu">
                                    <li class="has-dropdown has-dropdown1"><a href="#">Multipage</a>
                                        <ul class="sub-menu">
                                            <li><a href="/">Home 1</a></li>
                                            <li><a href="/home2MultiPagel">Home 2</a></li>
                                            <li><a href="/home2MultiPage">Home 3</a></li>
                                            <li><a href="/homeIndexMultiPage">Home 4</a></li>
                                        </ul>
                                    </li>
                                    <li class="has-dropdown has-dropdown1"><a href="#">Landing Page</a>
                                        <ul class="sub-menu">
                                            <li><a href="single-/">Home 1</a></li>
                                            <li><a href="/home2MultiPage">Home 2</a></li>
                                            <li><a href="/home2SinglePage">Home 3</a></li>
                                            <li><a href="single-/homeIndexMultiPage">Home 4 </a></li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li><a href="/about">About Us</a></li>
                            <li class="has-dropdown"><a href="#">Market</a>
                                <ul class="sub-menu">
                                    <li><a href="/market">Market Update</a></li>
                                    <li><a href="/buyCrypto">Buy Crypto</a></li>
                                    <li><a href="/sellBuyCrypto">Sell Crypto</a></li>
                                </ul>
                            </li>

                            <li class="has-dropdown"><a href="#">Pages</a>
                                <ul class="sub-menu">
                                    <li><a href="/contact">Contact</a></li>
                                    <li><a href="/faq">FAQ</a></li>
                                    <li><a href="/error">404</a></li>
                                </ul>
                            </li>

                            <li><a href="/blog">Blog</a></li>
                            <li class="has-dropdown has-dropdown1"><a href="/blogDetail" class="main">Blog Detials</a>
                                <ul class="sub-menu">
                                    <li><a href="/blogDetailLeft">Details Left</a></li>
                                    <li><a href="/blogDetailRight">Details Right</a></li>
                                    <li><a href="/blogDetail">Single Details</a></li>
                                </ul>
                            </li>

                            <li class="has-dropdown"><a href="#">Account</a>
                                <ul class="sub-menu">
                                    <li><a href="/user">My Profile</a></li>
                                    <li><a href="/login">Login</a></li>
                                    <li><a href="/register">Register</a></li>
                                </ul>
                            </li>

                        </ul>

                        <div class="mobile-button">
                            <a href="/register" class="btn_theme btn_theme_active mt_40 wow fadeInDown" data-wow-duration="0.8s">Join the Revolution <i class="fa-solid fa-arrow-right"></i><span></span></a>
                        </div>

                        <div class="single-footer-items">
                            <h3>Contact Us</h3>

                            <div class="contact-box">
                                <div class="pera">
                                    <a href="tel:+880123456789">+880 123 456 789</a>
                                </div>
                            </div>

                            <div class="contact-box">
                                <div class="pera">
                                    <a href="mailto:info@mail.com">info@mail.com</a>
                                </div>
                            </div>

                            <div class="contact-box">
                                <div class="pera">
                                    <a href="tel:+880123456789">8502 Preston Rd. <br /> Inglewoo Maine 98380</a>
                                </div>
                            </div>

                        </div>

                        <div class="contact-infos">
                            <h3>Our Location</h3>
                            <ul class="social-icon">
                                <li><a href="#"><FontAwesomeIcon icon={faLinkedinIn} /></a></li>
                                <li><a href="#"><FontAwesomeIcon icon={faTwitter} /></a></li>
                                <li><a href="#"><FontAwesomeIcon icon={faYoutube} /></a></li>
                                <li><a href="#"><FontAwesomeIcon icon={faInstagram} /></a></li>
                            </ul>
                        </div>

                    </div>
                </div>


                <div class="hero-area2" style={{ backgroundImage: `url(${require('../../img/bg/hero2-bg.png')})` }}>
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-lg-6">
                                <div class="main-heading">
                                    <span class="span" data-aos="fade-right" data-aos-duration="700">Invest In The Future Of PayCoin</span>
                                    <h1 data-aos="fade-right" data-aos-duration="900">The Future is Here : Invest in <span class="after">PayCoin</span></h1>
                                    <div class="space16"></div>
                                    <p data-aos="fade-right" data-aos-duration="1100">PayCoin, where innovation meets investment. Our groundbreaking an platform is poised to revolutionise the PayCoin landscape through.</p>
                                    <div class="space30"></div>
                                    <div class="buttons" data-aos="fade-right" data-aos-duration="1300">
                                        <a href="/buyCrypto" class="btn_theme btn_theme_active mt_40 wow fadeInDown" data-wow-duration="0.8s">Join the Revolution <i class="fa-solid fa-arrow-right"></i><span></span></a>

                                        <div class="hero-button1 video-action-btn1 popup-youtube">
                                            <div class="">
                                                <a id="play-video" class="video-play-button play-btn" href="https://www.youtube.com/watch?v=Y8XpQpW5OVY">
                                                    <span></span>
                                                </a>
                                            </div>
                                            <div class="video-btn-pera">
                                                <p>Play Video</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6">
                                <div class="images-area">
                                    <div class="image1 reveal">
                                        <img src={hrmian} alt="" />
                                    </div>

                                    <div class="image2 animate6">
                                        <img src={hrco} alt="" />
                                    </div>

                                    <div class="image3 animate1 reveal">
                                        <img src={dsh} alt="" />
                                    </div>

                                    <div class="image4 animate3 reveal ">
                                        <img src={dsh2} alt="" />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <img src={service10} alt="" class="circle-shape1" />
                    <img src={service101} alt="" class="circle-shape2 shape-animaiton4" />
                    <img src={service102} alt="" class="shape1 animate1" />
                    <img src={service103} alt="" class="shape2 animate6" />
                </div>

                <div class="about2 sp">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6 m-auto text-center">
                                <div class="heading2">
                                    <span class="span" data-aos="zoom-in-left" data-aos-duration="700"><span>what is paycoin?</span></span>
                                    <h2 class="text-anime-style-3">What We Do PayCoin</h2>
                                </div>
                            </div>
                        </div>

                        <div class="space60"></div>
                        <div class="row align-items-center">
                            <div class="col-lg-6">
                                <div class="space30"></div>
                                <div class="about2-images">
                                    <div class="image1">
                                        <img src={aboumain} alt="" />
                                    </div>
                                    <div class="image2">
                                        <img src={abtmain} alt="" />
                                    </div>
                                    <div class="image3 animate6">
                                        <img src={abtmn} alt="" />
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6">
                                <div class="about2-boxs">
                                    <div class="single-box" data-aos="fade-up" data-aos-duration="700">
                                        <div class="">
                                            <div class="icon">
                                                <img src={abtmn3} alt="" />
                                            </div>
                                        </div>
                                        <div class="heading2">
                                            <h4><a href="/buyCrypto">Automatic Conversion</a></h4>
                                            <div class="space16"></div>
                                            <p>Our team of experts has meticulously crafted PayCoin  address the key a challenges facing</p>
                                        </div>
                                    </div>

                                    <div class="single-box" data-aos="fade-up" data-aos-duration="900">
                                        <div class="">
                                            <div class="icon">
                                                <img src={abttmn} alt="" />
                                            </div>
                                        </div>
                                        <div class="heading2">
                                            <h4><a href="/buyCrypto">Simple to manage</a></h4>
                                            <div class="space16"></div>
                                            <p>With PayCoin, investors have the chance to a participate in a project that not only offers.</p>
                                        </div>
                                    </div>

                                    <div class="single-box" data-aos="fade-up" data-aos-duration="1100">
                                        <div class="">
                                            <div class="icon">
                                                <img src={abtim} alt="" />
                                            </div>
                                        </div>
                                        <div class="heading2">
                                            <h4><a href="/buyCrypto">quick to set up</a></h4>
                                            <div class="space16"></div>
                                            <p>Our experienced team is dedicated to PayCoin building  platform that streamlines processes.</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <img src={abtmn2} alt="" class="sec-shape" />
                </div>

                <div class="token-sell sp2 _relative">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-7 m-auto text-center">
                                <div class="heading2">
                                    <span class="span" data-aos="zoom-in-left" data-aos-duration="700"><span>Token Buy & Sell</span></span>
                                    <h2 class="text-anime-style-3">Token Structure PayCoin</h2>
                                </div>
                            </div>
                        </div>

                        <div class="row align-items-center">
                            <div class="col-lg-3">
                                <div class="box-area-all" data-aos="flip-right" data-aos-duration="900">
                                    <div class="icon">
                                        <img src={abc2} alt="" />
                                    </div>
                                    <div class="single-box heading2">
                                        <h5><a href="/buyCrypto">Private Pre-Sale</a></h5>
                                        <div class="space10"></div>
                                        <p>June 20, 2018</p>
                                    </div>
                                </div>

                                <div class="space50"></div>
                                <div class="box-area-all box-area-all2" data-aos="flip-right" data-aos-duration="900">
                                    <div class="icon">
                                        <img src={abc} alt="" />
                                    </div>
                                    <div class="single-box heading2">
                                        <h5><a href="/buyCrypto">Crowdsale</a></h5>
                                        <div class="space10"></div>
                                        <p>June 20, 2018</p>
                                    </div>
                                </div>

                            </div>

                            <div class="col-lg-6">
                                <div class="token_sale" data-aos="zoom-out" data-aos-duration="900">
                                    <div class="tk_countdown">
                                        <div class="tk_counter_inner">

                                            <div id="timer">
                                                <div class="time" id="days"></div>
                                                <div class="time" id="hours"></div>
                                                <div class="time" id="minutes"></div>
                                            </div>
                                            <div class="space70"></div>
                                            <div class="progress-bar-area">
                                                <div class="progress animation" data-animation="fadeInUp" data-animation-delay="1.3s">
                                                    <div class="progress-bar progress-bar-striped" role="progressbar" aria-valuenow="46" aria-valuemin="0" aria-valuemax="100" style={{ width: "46%" }}> 46% </div>
                                                </div>
                                                <ul class="progress-texts">
                                                    <li class="text1">Sale Raised</li>
                                                    <li class="text2">Soft-Caps</li>
                                                    <li class="text3">4,600 BCC</li>
                                                    <li class="text4">8,600 BCC</li>
                                                    <li class="after1"></li>
                                                    <li class="after2"></li>
                                                </ul>

                                                <div class="space60"></div>
                                                <a href="/buyCrypto" class="btn_theme btn_theme_active mt_40 wow fadeInDown" data-wow-duration="0.8s">Join the Revolution <i class="fa-solid fa-arrow-right"></i><span></span></a>
                                                <ul class="bank-list">
                                                    <li>
                                                        <a href="#"><img src={bnk} alt="" /></a>
                                                        <a href="#"><img src={bnk2} alt="" /></a>
                                                        <a href="#"><img src={bnk3} alt="" /></a>
                                                        <a href="#"><img src={bnk4} alt="" /></a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="shape1">
                                        <img src={sell} alt="" />
                                    </div>

                                    <div class="shape2">
                                        <img src={sell2} alt="" />
                                    </div>

                                    <div class="shape3">
                                        <img src={sell3} alt="" />
                                    </div>

                                    <div class="shape4">
                                        <img src={sell4} alt="" />
                                    </div>

                                </div>

                            </div>

                            <div class="col-lg-3">
                                <div class="box-area-all box-area-all3" data-aos="flip-right" data-aos-duration="900">
                                    <div class="icon">
                                        <img src={selt} alt="" />
                                    </div>
                                    <div class="single-box heading2">
                                        <h5><a href="/buyCrypto">Total Token Sale</a></h5>
                                        <div class="space10"></div>
                                        <p>855,000 BCC (8.2%)</p>
                                    </div>
                                </div>

                                <div class="space50"></div>
                                <div class="box-area-all box-area-all4" data-aos="flip-right" data-aos-duration="900">
                                    <div class="icon">
                                        <img src={tokenimg} alt="" />
                                    </div>
                                    <div class="single-box heading2">
                                        <h5><a href="/buyCrypto">Acceptable Currency</a></h5>
                                        <div class="space10"></div>
                                        <p>BTC, ETH, LTC</p>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                    <img class="token-sell-shape animate3" src={tatimg} alt="" />
                </div>

                <div class="work2 pb120">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6 m-auto text-center">
                                <div class="heading2">
                                    <span class="span" data-aos="zoom-in-left" data-aos-duration="700"><span>Work process</span></span>
                                    <h2 class="text-anime-style-3">How It Works</h2>
                                </div>
                            </div>
                        </div>

                        <div class="space30"></div>
                        <div class="row">
                            <div class="col-lg-4 col-md-6" data-aos="zoom-in-up" data-aos-duration="1100">
                                <div class="work2-box-area">
                                    <div class="icon-area">
                                        <div class="icon">
                                            <img src={workimg4} alt="" />
                                        </div>
                                    </div>
                                    <div class="single-box">
                                        <div class="heading2">
                                            <h4><a href="/login">Download Wallet</a></h4>
                                            <div class="space16"></div>
                                            <p>Bitcoin is received, stored, and sent using software known as a Bitcoin Wallet. Download the official Bitcoin Wallet for free.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6" data-aos="zoom-in-up" data-aos-duration="900">
                                <div class="work2-box-area active">
                                    <div class="icon-area">
                                        <div class="icon">
                                            <img src={workimg3} alt="" />
                                        </div>
                                    </div>
                                    <div class="single-box">
                                        <div class="heading2">
                                            <h4><a href="/login">Safe And Secure</a></h4>
                                            <div class="space16"></div>
                                            <p>Our team ultimate solution for PayCoin. By leveraging safe blockchain technology, we're revolutionising safe & secure. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6" data-aos="zoom-in-up" data-aos-duration="700">
                                <div class="work2-box-area">
                                    <div class="icon-area">
                                        <div class="icon">
                                            <img src={workimg2} alt="" />
                                        </div>
                                    </div>
                                    <div class="single-box">
                                        <div class="heading2">
                                            <h4><a href="/login">Download And Sell</a></h4>
                                            <div class="space16"></div>
                                            <p>ICO, you're not just investing in a project – you're investing in a vision for a brighter future. Join us today and be part of Coin.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <img class="shape" src={workimg} alt="" />
                </div>

                <div class="roadmap pb120 _relative d-none d-lg-block">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-7 m-auto text-center">
                                <div class="heading2">
                                    <span class="span" data-aos="zoom-in-left" data-aos-duration="700"><span>Paycoin Roadmap</span></span>
                                    <h2 class="text-anime-style-3">Our iCO Roadmap</h2>
                                </div>
                            </div>
                        </div>

                        <div class="space30"></div>
                        <div class="row">
                            <div class="col-lg-10 m-auto">
                                <div class="roadmap-boxs">
                                    <div class="row align-items-center parent-area active">
                                        <div class="col-lg-6">
                                            <div class="circle-box-area">
                                                <div class="circle-box">
                                                    <p>12 April</p>
                                                    <h3>2021</h3>
                                                </div>
                                                <img src={roadmap} alt="" class="line-shape" />
                                            </div>
                                        </div>

                                        <div class="col-lg-6" data-aos="fade-up" data-aos-duration="800">
                                            <div class="roadmap-box heading2">
                                                <h4><a href="/buyCrypto">Listing to the major exchanges</a></h4>
                                                <div class="space16"></div>
                                                <p>We understand the importance of accessibility and liquidity for our token holders. That's why we're are committed to listing our token on major PayCoin.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row align-items-center parent-area">

                                        <div class="col-lg-6" data-aos="fade-up" data-aos-duration="800">
                                            <div class="roadmap-box heading2 right">
                                                <h4><a href="/buyCrypto">Platform Development Starts</a></h4>
                                                <div class="space16"></div>
                                                <p>We understand the importance of accessibility and liquidity for our token holders. That's why we're are committed to listing our token on major PayCoin.</p>
                                            </div>
                                        </div>

                                        <div class="col-lg-6">
                                            <div class="circle-box-area right">
                                                <div class="circle-box">
                                                    <p>17 June</p>
                                                    <h3>2022</h3>
                                                </div>
                                                <img src={roadmap} alt="" class="line-shape" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row align-items-center parent-area">
                                        <div class="col-lg-6">
                                            <div class="circle-box-area">
                                                <div class="circle-box">
                                                    <p>11 June</p>
                                                    <h3>2023</h3>
                                                </div>
                                                <img src={roadmap} alt="" class="line-shape" />
                                            </div>
                                        </div>

                                        <div class="col-lg-6" data-aos="fade-up" data-aos-duration="800">
                                            <div class="roadmap-box heading2">
                                                <h4><a href="/buyCrypto">Platform Integration Marketplaces</a></h4>
                                                <div class="space16"></div>
                                                <p>We understand the importance of accessibility and liquidity for our token holders. That's why we're are committed to listing our token on major PayCoin.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row align-items-center parent-area">

                                        <div class="col-lg-6" data-aos="fade-up" data-aos-duration="800">
                                            <div class="roadmap-box heading2 right">
                                                <h4><a href="/buyCrypto">Crypto Wallet Version Release</a></h4>
                                                <div class="space16"></div>
                                                <p>We understand the importance of accessibility and liquidity for our token holders. That's why we're are committed to listing our token on major PayCoin.</p>
                                            </div>
                                        </div>

                                        <div class="col-lg-6">
                                            <div class="circle-box-area right">
                                                <div class="circle-box">
                                                    <p>23 April</p>
                                                    <h3>2024</h3>
                                                </div>
                                                <img src={roadmap} alt="" class="line-shape" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row align-items-center parent-area">
                                        <div class="col-lg-6">
                                            <div class="circle-box-area">
                                                <div class="circle-box">
                                                    <p>22 March</p>
                                                    <h3>2024</h3>
                                                </div>
                                                <img src={roadmap} alt="" class="line-shape" />
                                            </div>
                                        </div>

                                        <div class="col-lg-6" data-aos="fade-up" data-aos-duration="800">
                                            <div class="roadmap-box heading2">
                                                <h4><a href="/buyCrypto">Groundwork Preparation For ICO</a></h4>
                                                <div class="space16"></div>
                                                <p>We understand the importance of accessibility and liquidity for our token holders. That's why we're are committed to listing our token on major PayCoin.</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <img src={shapimg} alt="" class="sec-shape" />
                </div>


                <div class="roadmap pb120 _relative d-block d-lg-none">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-7 m-auto text-center">
                                <div class="heading2">
                                    <span class="span" data-aos="zoom-in-left" data-aos-duration="700"><span>Paycoin Roadmap</span></span>
                                    <h2 class="text-anime-style-3">Our iCO Roadmap</h2>
                                </div>
                            </div>
                        </div>

                        <div class="space30"></div>
                        <div class="row">
                            <div class="col-lg-10 m-auto">
                                <div class="roadmap-boxs">
                                    <div class="row align-items-center parent-area active">
                                        <div class="col-lg-6">
                                            <div class="circle-box-area">
                                                <div class="circle-box">
                                                    <p>12 April</p>
                                                    <h3>2021</h3>
                                                </div>
                                                <img src={roadmap} alt="" class="line-shape" />
                                            </div>
                                        </div>

                                        <div class="col-lg-6" data-aos="fade-up" data-aos-duration="800">
                                            <div class="roadmap-box heading2">
                                                <h4><a href="/buyCrypto">Listing to the major exchanges</a></h4>
                                                <div class="space16"></div>
                                                <p>We understand the importance of accessibility and liquidity for our token holders. That's why we're are committed to listing our token on major PayCoin.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row align-items-center parent-area active">
                                        <div class="col-lg-6">
                                            <div class="circle-box-area">
                                                <div class="circle-box">
                                                    <p>12 April</p>
                                                    <h3>2022</h3>
                                                </div>
                                                <img src={roadmap} alt="" class="line-shape" />
                                            </div>
                                        </div>

                                        <div class="col-lg-6" data-aos="fade-up" data-aos-duration="800">
                                            <div class="roadmap-box heading2">
                                                <h4><a href="/buyCrypto">Platform Development Starts</a></h4>
                                                <div class="space16"></div>
                                                <p>We understand the importance of accessibility and liquidity for our token holders. That's why we're are committed to listing our token on major PayCoin.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row align-items-center parent-area active">
                                        <div class="col-lg-6">
                                            <div class="circle-box-area">
                                                <div class="circle-box">
                                                    <p>12 April</p>
                                                    <h3>2023</h3>
                                                </div>
                                                <img src={roadmap} alt="" class="line-shape" />
                                            </div>
                                        </div>

                                        <div class="col-lg-6" data-aos="fade-up" data-aos-duration="800">
                                            <div class="roadmap-box heading2">
                                                <h4><a href="/buyCrypto">Platform Integration Marketplaces</a></h4>
                                                <div class="space16"></div>
                                                <p>We understand the importance of accessibility and liquidity for our token holders. That's why we're are committed to listing our token on major PayCoin.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row align-items-center parent-area active">
                                        <div class="col-lg-6">
                                            <div class="circle-box-area">
                                                <div class="circle-box">
                                                    <p>12 April</p>
                                                    <h3>2024</h3>
                                                </div>
                                                <img src={roadmap} alt="" class="line-shape" />
                                            </div>
                                        </div>

                                        <div class="col-lg-6" data-aos="fade-up" data-aos-duration="800">
                                            <div class="roadmap-box heading2">
                                                <h4><a href="/buyCrypto">Crypto Wallet Version Release</a></h4>
                                                <div class="space16"></div>
                                                <p>We understand the importance of accessibility and liquidity for our token holders. That's why we're are committed to listing our token on major PayCoin.</p>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                    <img src={testiii2} alt="" class="sec-shape" />
                </div>

                <div class="others2" style={{ backgroundImage: ` url(${require('../../img/bg/others2-bg.png')})` }}>
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-lg-6">
                                <div class="heading">
                                    <span class="span" data-aos="zoom-in-left" data-aos-duration="700">Available mobile app</span>
                                    <h2 class="text-anime-style-3">Download Mobile app</h2>
                                    <div class="space16"></div>
                                    <p data-aos="fade-right" data-aos-duration="800">Being part of this ICO journey has been nothing short of extra. The team's dedication to transforming PayCoin blockchain technology is palpable, and their commitment to transparency and excellence.</p>

                                    <div class="space30"></div>
                                    <div class="buttons" data-aos="fade-right" data-aos-duration="1000">
                                        <a href="#"><img src={other} alt="" /></a>
                                        <a href="#"><img src={other2} alt="" /></a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="main-image" data-aos="fade-left" data-aos-duration="1000" data-aos-offset="100">
                                    <img src={othed} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tes2 sp2">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6 m-auto text-center">
                                <div class="heading2">
                                    <span class="span" data-aos="zoom-in-left" data-aos-duration="700"><span>TESTIMONIALS</span></span>
                                    <h2 class="text-anime-style-3">From Our Investor</h2>
                                </div>
                            </div>
                        </div>

                        <div class="space30"></div>
                        <div class="row align-items-center">
                            <div class="col-lg-5">
                                <div class="space40"></div>
                                <div class="main-image image-anime" data-aos="flip-right" data-aos-duration="800">
                                    <img src={test2} alt="" />
                                </div>

                            </div>

                            {/* <div class="col-lg-7 _relative">
                                <div class="tes2-slider" data-aos="fade-up" data-aos-duration="800">
                                    <div class="single-slider">
                                        <div class="icon">
                                            <img src={qut} alt="" />
                                        </div>
                                        <div class="space20"></div>
                                        <p class="pera">"Joining this ICO was one of the best decisions I've made in the crypto space. The team's dedication a to innovation and their commitment to delivering & on promises sets them apart. I'm excited to be.”</p>

                                        <div class="bottom-area">
                                            <div class="image">
                                                <img src={tsetbtn} alt="" />
                                            </div>
                                            <div class="heading">
                                                <h5><a href="#">Shakib Mahmud</a></h5>
                                                <p>Operating Officer</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="single-slider">
                                        <div class="icon">
                                            <img src={qt} alt="" />
                                        </div>
                                        <div class="space20"></div>
                                        <p class="pera">"Joining this ICO was one of the best decisions I've made in the crypto space. The team's dedication a to innovation and their commitment to delivering & on promises sets them apart. I'm excited to be.”</p>

                                        <div class="bottom-area">
                                            <div class="image">
                                                <img src={qt2} alt="" />
                                            </div>
                                            <div class="heading">
                                                <h5><a href="#">Shakib Mahmud</a></h5>
                                                <p>Operating Officer</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div class="nav-area">
                                    <button class="arrow-left"><i class="fa-solid fa-angle-left"></i></button>
                                    <button class="arrow-right"><i class="fa-solid fa-angle-right"></i></button>
                                </div>
                            </div> */}

                            <div className="col-lg-7 _relative">
                                <Swiper
                                    // modules={[Navigation]} // Enable navigation module
                                    spaceBetween={50}
                                    slidesPerView={1}
                                    navigation={{
                                        nextEl: '.arrow-right',
                                        prevEl: '.arrow-left',
                                    }}
                                    loop={true}
                                    pagination={{ clickable: true }}
                                    autoplay={{
                                        delay: 3000, // 3 seconds
                                        disableOnInteraction: false, // Keeps autoplay after user interaction
                                    }}
                                    // data-aos="fade-up"
                                    // data-aos-duration="800"
                                    className="tes2-slider"
                                >
                                    <SwiperSlide>
                                        <div className="single-slider">
                                            <div className="icon">
                                                <img src={qut} alt="" />
                                            </div>
                                            <div className="space20"></div>
                                            <p className="pera">"Joining this ICO was one of the best decisions I've made in the crypto space. The team's dedication to innovation and their commitment to delivering on promises sets them apart. I'm excited to be.”</p>
                                            <div className="bottom-area">
                                                <div className="image">
                                                    <img src={tsetbtn} alt="" />
                                                </div>
                                                <div className="heading">
                                                    <h5><a href="#">Shakib Mahmud</a></h5>
                                                    <p>Operating Officer</p>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>

                                    <SwiperSlide>
                                        <div className="single-slider">
                                            <div className="icon">
                                                <img src={qt} alt="" />
                                            </div>
                                            <div className="space20"></div>
                                            <p className="pera">"Joining this ICO was one of the best decisions I've made in the crypto space. The team's dedication to innovation and their commitment to delivering on promises sets them apart. I'm excited to be.”</p>
                                            <div className="bottom-area">
                                                <div className="image">
                                                    <img src={qt2} alt="" />
                                                </div>
                                                <div className="heading">
                                                    <h5><a href="#">Shakib Mahmud</a></h5>
                                                    <p>Operating Officer</p>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                </Swiper>

                                {/* Navigation Buttons */}
                                <div className="nav-area">
                                    <button className="arrow-left" style={{ zIndex: "1" }}><i className="fa-solid fa-angle-left"></i></button>
                                    {/* <button className="arrow-left" style={{ zIndex: "1" }}><i><FontAwesomeIcon icon={faChevronRight} style={{ height: "1.2rem" }} /></i></button> */}
                                    <button className="arrow-right" style={{ zIndex: "1" }}><i className="fa-solid fa-angle-right"></i></button>
                                    {/* <button className="arrow-right" style={{ zIndex: "1" }}><i><FontAwesomeIcon icon={faChevronLeft} style={{ height: "1.2rem" }} /></i></button> */}
                                </div>
                            </div>

                        </div>
                    </div>
                    <img src={test1} alt="" class="sec-shape animate3" />
                </div>

                <div class="blog2 pb120">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-lg-5">
                                <div class="heading2">
                                    <span class="span" data-aos="zoom-in-left" data-aos-duration="700"><span>OUr Blog</span></span>
                                    <h2 class="text-anime-style-3">Blog & News</h2>
                                    <div class="space16"></div>
                                    <p data-aos="fade-right" data-aos-duration="800">Being part of this ICO journey has been nothing short of extra. The team's dedication to transforming to the PayCoin blockchain technology is palpable, and their commitment to transparency and excellence.</p>
                                    <div class="space30"></div>
                                    <div class="" data-aos="fade-right" data-aos-duration="900">
                                        <a href="/blog" class="btn_theme btn_theme_active mt_40 wow fadeInDown" data-wow-duration="0.8s">read more blog <i class="fa-solid fa-arrow-right"></i><span></span></a>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-7">
                                <div class="blog2-box" data-aos="fade-up" data-aos-duration="700">
                                    <div class="">
                                        <div class="image image-anime">
                                            <img src={blogImg5} alt="" />
                                        </div>
                                    </div>
                                    <div class="heading2">
                                        <h3><a href="/blogDetail">Unlocking the Future The Pay Power of ICO Cryptocurrency</a></h3>
                                        <div class="space16"></div>
                                        <p>One of the most significant advantages of ICOs is their ability to democratise.</p>
                                        <a href="/blogDetail" class="learn">Read More <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                    </div>
                                </div>

                                <div class="blog2-box" data-aos="fade-up" data-aos-duration="900">
                                    <div class="">
                                        <div class="image image-anime">
                                            <img src={blogImg} alt="" />
                                        </div>
                                    </div>
                                    <div class="heading2">
                                        <h3><a href="/blogDetail">The Rise of ICOs A New Era of Investment Of Opportunities</a></h3>
                                        <div class="space16"></div>
                                        <p>In recent years, Initial Coin Offerings Of (ICOs) have emerged as revolutionary</p>
                                        <a href="/blogDetail" class="learn">Read More <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="cta2">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-7 m-auto text-center">
                                <div class="heading">
                                    <span class="span">COMMUNITY-OWNED AND OPERATED</span>
                                    <h2>Ready  Embrace The Future
                                        Of Investing With ICOs?</h2>
                                    <div class="space30"></div>
                                    <div class="buttons">
                                        <a href="/market" class="btn_theme2 btn_theme_active2 mt_40 wow fadeInDown" data-wow-duration="0.8s">Discover Opportunities <i class="fa-solid fa-arrow-right"></i><span></span></a>
                                        <a href="/market" class="btn_theme2 btn_theme_active2 mt_40 wow fadeInDown" data-wow-duration="0.8s">Invest Today <i class="fa-solid fa-arrow-right"></i><span></span></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img src={authorImg} alt="" class="circle1" />
                    <img src={dateImg} alt="" class="circle2 shape-animaiton4" />
                </div>

                <div class="cta2-images">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-10 m-auto text-center">
                                <div class="images-area">
                                    <div class="image1">
                                        <img src={coinImg2} alt="" />
                                    </div>

                                    <div class="image2">
                                        <img src={cta1} alt="" />
                                    </div>
                                    <div class="image3">
                                        <img src={cta2} alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="footer2 _relative">
                    <div class="container">
                        <div class="footer-bg">
                            <div class="row">
                                <div class="col-lg-4 col-md-6 col-12">
                                    <div class="footer-logo-area">
                                        <a href="/" class="logo">
                                            <img src={FooterImg} alt="" />
                                        </a>
                                        <div class="space20"></div>
                                        <h5>Join Our Blockchain PayCoin Community</h5>
                                        <div class="space30"></div>
                                        <a href="/register" class="btn_theme2 btn_theme_active2 mt_40 wow fadeInDown" data-wow-duration="0.8s">Join Now <i class="fa-solid fa-arrow-right"></i><span></span></a>
                                    </div>
                                </div>

                                <div class="col-lg col-md-4 col-6">
                                    <div class="single-footer-items">
                                        <h3>Explore</h3>

                                        <ul class="menu-list">
                                            <li><a href="#">Tokens Sale</a></li>
                                            <li><a href="#">Ecosystem</a></li>
                                            <li><a href="#">Wallets Sale </a></li>
                                            <li><a href="#">Gravity Dex</a></li>
                                            <li><a href="#">Whitepaper</a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="col-lg col-md-4 col-6">
                                    <div class="single-footer-items">
                                        <h3>Solution</h3>

                                        <ul class="menu-list">
                                            <li><a href="#">Token Suite</a></li>
                                            <li><a href="#">Work Process</a></li>
                                            <li><a href="#">Wallets Sale </a></li>
                                            <li><a href="#">Tokenisation</a></li>
                                            <li><a href="#">Portal Token</a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="col-lg col-md-4 col-6">
                                    <div class="single-footer-items pl-5">
                                        <h3>Quick Links</h3>

                                        <ul class="menu-list">
                                            <li><a href="/homeMultipage">Our Features </a></li>
                                        <li><a href="/Why Blockchain">Why Blockchain</a></li>
                                        <li><a href="/blog">Our Blog</a></li>
                                        <li><a href="/">Introduction</a></li>
                                        <li><a href="/contact">Contact Us</a></li>
                                        </ul>
                                    </div>
                                </div>


                                <div class="col-lg-2 col-md-4 col-6">
                                    <div class="single-footer-items">
                                        <h3>Need Help?</h3>

                                        <ul class="contact-info">
                                            <li><a href="tel:+(1)1234567890">+(1) 123 456 7890</a></li>
                                            <li><a href="mailto:paycoindemo@.com">paycoindemo@.com</a></li>
                                            <li><a href="#">paycoinwebsite.com</a></li>
                                        </ul>

                                        <ul class="icons">
                                            <li><a href="#"><FontAwesomeIcon icon={faFacebookF} /></a></li>
                                            <li><a href="#"><FontAwesomeIcon icon={faGooglePlusG} /></a></li>
                                            <li><a href="#"><FontAwesomeIcon icon={faLinkedinIn} /></a></li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="space70"></div>
                    </div>

                    <div class="copyright-area _relative">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-12 text-center">
                                    <div class="coppyright">
                                        <p>Copyright © 2024 PayCoin crypto theme. All rights reserved.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <img src={footerimg1} alt="" class="shape" />

                </div>
            </div>
        </>
    )
}

export default SingleHomepage
